konnyScript(function($){
  newbornCateSwiper = new Swiper("#newbornCateSlider", {
      slidesPerView: 2.5,
      spaceBetween: 0,
      freeMode: false,
      freeModeSticky: true,
      grabCursor: true,
      loop: false,
      resistanceRatio: 0,
      touchReleaseOnEdges: true,
      allowSlidePrev: true,
      allowSlideNext: true,
      noSwiping: true,
      keyboard: {
          enabled: true,
      },
      autoHeight: false,
      scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
      },
      breakpoints: {
          750: {
              slidesPerView: 6, // 750px 이하에서
          }
      }
  });
});